import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type ReviewResultsFragment = { score?: number | null, reviewerId: string, reviewedAt?: string | null, name?: string | null, profilePicture?: string | null, approved: boolean };


export type ReviewResultsFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const ReviewResultsFragmentDoc = /*#__PURE__*/ gql`
    fragment ReviewResults on ExerciseReviewType {
  score
  reviewerId
  reviewedAt
  name
  profilePicture
  approved
}
    `;